export default __webpack_public_path__ + "static/media/veteran-leadership.e13e10ab.png";